import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import Styles from './InstructionPane.module.scss'
import { marked } from 'marked';
import { CodeBlock } from 'components/CodeBlock/CodeBlock';
import { Dialog } from '@mui/material';
import DOMPurify from 'dompurify';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

export function InstructionPane({
    props,
    steps,
    currentStep,
    isMuted,
    copied,
    onHandleVoiceClick,
    isCopyEnabled,
    onHandleCopy,
    onHandleCopyDisabled,
    onHandleCopyButton,
    nodeInfo,
    setIsWebPageOpen,
    isWebPageOpen,
    nodeAPI,
    nodeSet,
    showLineNumbers,
    nodeCTD,
    setViewReference,
    nodeFinished,
    theme = 'light',
    displayCopyButton = true
}) {

    return (
        <div data-testid="instructionPane-instructionsContainer" id="instructionsContainer"
            className={`${Styles.instructionsContainer}`}
            style={{
                backgroundColor: theme === 'light' ? "#fff" : "#24292e",
                color: theme === 'light' ? "#24292e" : "#fff"
            }}
        >
            <>
                {!props?.live_assessment &&
                    <span data-testid="instructionPane-instructionsContainer-instructionButtons" className={Styles.instructionButtons}>
                        <button
                            data-testid="instructionPane-instructionsContainer-muteBtn"
                            className={Styles.muteBtn}
                            onClick={onHandleVoiceClick}
                        >
                            {isMuted ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
                        </button>
                        {(steps[currentStep]?.reference && !nodeFinished) && nodeCTD && <FeatherIcon data-testid="instructionPane-instructionsContainer-eyeIcon" icon='eye' color='#2596be' role='button' onClick={() => { setViewReference(true) }} />}
                    </span>
                }
                <div
                    id='instruction'
                    data-testid="instructionPane-instructionsContainer-instruction"
                    className={Styles.instruction}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(marked.parse(steps[currentStep]?.instructions || ''))
                    }}
                />
                {!(nodeInfo?.is_assessment === 1) && steps[currentStep]?.command && steps[currentStep].command.length > 0 ? (
                    <div className={Styles.codeBlockContainer}>
                        <CodeBlock
                            t={props.t}
                            language={nodeInfo?.resource?.config?.language}
                            value={steps[currentStep].command}
                            copied={copied}
                            isCopyEnabled={isCopyEnabled}
                            handleCopy={onHandleCopy}
                            handleCopyDisabled={onHandleCopyDisabled}
                            handleCopyButton={onHandleCopyButton}
                            theme={theme}
                            showLineNumbers={showLineNumbers}
                            displayCopyButton={displayCopyButton}
                        />
                    </div>
                ) : null}
                {(nodeAPI || nodeSet) && (
                    <>
                        {props.t('Labs.Nodes.NodeAPI.info')}:

                        <div
                            id="commandText"
                            data-testid="instructionPane-instructionsContainer-commandText"
                            className={Styles.codeText}
                            style={{
                                backgroundColor: theme === 'light' ? "#fff" : "#rgb(1, 22, 39)",

                                color: theme === 'light' ? "#24292e" : "#fff",
                                background: theme === 'light' ? "#fff" : "rgb(1, 22, 39)",
                                spellcheck: false
                            }}
                            readOnly
                        >
                            {nodeAPI && (
                                <>
                                    {JSON.stringify(
                                        {
                                            ...steps[currentStep].exp_input,
                                            endpoint: steps[currentStep].exp_input.endpoint
                                                .replace(/\\\//g, "/")
                                                .replace(/^\^|\$$/g, "")
                                                .replaceAll("\\", "")
                                        },
                                        null,
                                        2
                                    )}
                                </>
                            )}

                            {nodeSet && (
                                <>
                                    {JSON.stringify(
                                        steps[currentStep].expected_input,
                                        null,
                                        2
                                    )}
                                </>
                            )}
                        </div>
                    </>
                )}
                <Dialog
                    data-testid="instructionPane-instructionsContainer-dialog"
                    fullWidth={true}
                    maxWidth={window.innerWidth > 1280 ? "lg" : "md"}
                    open={isWebPageOpen}
                    onClose={() => { setIsWebPageOpen(!isWebPageOpen) }}
                    PaperProps={{
                        style: {
                            overflow: 'hidden'
                        }
                    }}
                >
                    <div data-testid="instructionPane-instructionsContainer-iframe" className={Styles.iframe}>
                        <iframe data-testid="instructionPane-instructionsContainer-iframeUrl" src={steps[currentStep]?.iframeUrl}
                            title="Aivagam"
                            height='650px'
                            width="100%"
                            allowFullScreen={true}
                        ></iframe>
                    </div>

                </Dialog>
            </>
        </div>
    );
};